import { COMMON_EVENT_NAMES } from "../../constants";

export const EVENT_NAME = {
  NAVIGATION: COMMON_EVENT_NAMES.NAVIGATED
};
